export const CALCULATION_PRICE_SERVICE = {
  cart: 'CART',
  plus: 'PLUS-CHECKOUT',
  checkout: 'ECOMM-CHECKOUT',
};

export const GAMIFICATION_THRESHOLD_TYPES = Object.freeze({
  NUMBER_OF_ITEMS: 'NUMBER_OF_ITEMS',
  PRODUCT_GRAMS: 'PRODUCT_GRAMS',
  SPENDING_AMOUNT: 'SPENDING_AMOUNT',
});
